import {
  USER_TOKEN,
  ADMIN_EMAIL,
  ADMIN_BUSINESS_NAME,
  ADMIN_TENANT,
  ADMIN_BUSINESS_ID,
  TEST_URl
} from '@/utils/constants'

export default {
  methods: {
    logout () {
      localStorage.removeItem(USER_TOKEN)
      this.$store.dispatch('terminal/resetTerminalState')
      this.$store.dispatch('bulkPayout/resetBulkPayoutState')
      this.$store.dispatch('auth/resetAuthState')
      this.$store.dispatch('report/resetReportState')
      this.$store.dispatch('transactions/resetTransactionsState')
      this.$store.dispatch('withdrawal/resetWithdrawalState')
      this.$store.dispatch('externalApi/resetExternalApiState')
      this.$store.dispatch('common/resetCommonState')
      this.$store.dispatch('notification/resetNotificationState')
      this.$router.push({ name: 'login' }).catch(() => {})
      localStorage.removeItem('vuex')
      localStorage.clear()
      localStorage.removeItem(ADMIN_EMAIL)
      localStorage.removeItem(ADMIN_BUSINESS_NAME)
      localStorage.removeItem(ADMIN_TENANT)
      localStorage.removeItem(ADMIN_BUSINESS_ID)
      if (localStorage.getItem(TEST_URl)) {
        localStorage.removeItem(TEST_URl)
        window.location.reload()
      }
    }
  }
}
